export enum BaseRoute {
  PATH = '/app/prestamo',
}
